export default "__VITE_ASSET__DqyHWBRa__"